import HeaderSponsored from '../../headerSponsored';
import './headerCardF1.sass';

/**
 * Renderiza el encabezado de una tarjeta de evento de Fórmula 1,
 * mostrando la liga y el estado actual del evento (en vivo, finalizado, próximo, etc.).
*/
export default function HeaderCardF1({ data, indexJson }) {
  return (
    <HeaderSponsored data={data} prefixClass="card-f1" indexJson={indexJson}/>
  )
}